import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

/**
 * LES-70: «+ Додати» у блоці «Доповніть образ» шухляди кошика — додає товар без переходу зі сторінки.
 * Після додавання шлемо CartAddEvent з HTML секцій кошика: cart-items-component перемальовує шухляду
 * (товари, суму, прогрес до безкоштовної доставки), cart-icon оновлює лічильник.
 * Делегування на document, бо вміст шухляди перемальовується (morph) після кожної зміни кошика.
 */
if (!window.__cartUpsellBound) {
  window.__cartUpsellBound = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-upsell-form]')) return;

    event.preventDefault();
    if (!form.reportValidity()) return;

    const button = form.querySelector('button[type="submit"]');
    const error = form.parentElement?.querySelector('[data-cart-upsell-error]');
    button?.setAttribute('aria-busy', 'true');
    error?.classList.add('hidden');

    const sectionIds = new Set();
    for (const element of document.querySelectorAll('cart-items-component')) {
      if (element instanceof HTMLElement && element.dataset.sectionId) sectionIds.add(element.dataset.sectionId);
    }

    const formData = new FormData(form);
    formData.append('sections', Array.from(sectionIds).join(','));
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('javascript', { body: formData }));
      const data = await response.json();

      if (data.status) {
        if (error) {
          error.textContent = data.description || data.message || '';
          error.classList.remove('hidden');
        }
        return;
      }

      const sections = data.sections || {};
      let itemCount;
      for (const html of Object.values(sections)) {
        const count = new DOMParser().parseFromString(String(html), 'text/html').querySelector('[ref="cartItemCount"]');
        if (count?.textContent) {
          itemCount = parseInt(count.textContent, 10);
          break;
        }
      }

      if (itemCount === undefined) {
        const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
        itemCount = cart.item_count;
      }

      form.dispatchEvent(
        new CartAddEvent({}, String(formData.get('id')), {
          source: 'cart-upsell',
          itemCount,
          productId: String(data.product_id ?? ''),
          variantId: String(data.variant_id ?? formData.get('id')),
          sections,
        })
      );
    } catch (e) {
      console.error(e);
    } finally {
      button?.removeAttribute('aria-busy');
    }
  });
}
